<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" title="打印" icon="el-icon-printer" class="search-btn btn-primary" @click="print(0)">一键打印全部</el-button>
                <el-button size="small" title="打印" icon="el-icon-printer" class="search-btn btn-primary" @click="print(1)">打印所选</el-button>
                <span style="color: red"> （勾选需要打印的某天出/入库单，如果勾选多天的出入库记录将会合并打印）</span>
            </div>
        </div>
        <div class="orderdata">
            {{ '【 ' + cusName + ' 】 ' + (type == 0 ? '采购' : '销售') + '单号：' + orderCode }}
        </div>
        <div class="block">
            <el-timeline>
                <el-timeline-item :timestamp="item.Date" placement="top" v-for="(item, index) in dateDatas" v-bind:key="index">
                    <el-card>
                        <el-table
                            :data="item.Records"
                            border
                            style="width: 100%"
                            ref="multipleTable"
                            :header-cell-style="{ background: '#F2F6FC' }"
                            @selection-change="handleSelectionChange($event, item.Date)"
                        >
                            <el-table-column type="selection" width="50"></el-table-column>
                            <el-table-column prop="APCode" label="配件编码" min-width="160"> </el-table-column>
                            <el-table-column prop="APName" label="配件名称" min-width="180"> </el-table-column>
                            <el-table-column prop="AutoSerise" label="适用车型" min-width="160"> </el-table-column>
                            <el-table-column prop="Count" :label="type == 0 ? '入库数量' : '出库数量'" min-width="100"> </el-table-column>
                            <el-table-column prop="Unit" label="单位"> </el-table-column>
                            <el-table-column prop="Price" :label="type == 0 ? '采购价格' : '销售价格'">
                                <template slot-scope="scope">
                                    {{ scope.row.Price.toFixed(1) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Count" :label="type == 0 ? '采购总价' : '销售总价'">
                                <template slot-scope="scope">
                                    {{ (scope.row.Price * scope.row.Count).toFixed(1) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="RecordTime" label="出入库时间" min-width="160"> </el-table-column>
                        </el-table>
                    </el-card>
                </el-timeline-item>
            </el-timeline>
        </div>
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printOutDialogVisible" width="870px">
            <div class="dialog-content" v-if="printOutDialogVisible">
                <printOutContent @closeDialog="closeDialog" :printId="orderId" :printType="printType" :recordIds="printRecordIds"></printOutContent>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printInDialogVisible" width="870px">
            <div class="dialog-content" v-if="printInDialogVisible">
                <printInContent @closeDialog="closeDialog" :printId="orderId" :printType="printType" :recordIds="printRecordIds"></printInContent>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import printInContent from '@/components/business/goods/printsupplierOrderIn.vue';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        printInContent
    },
    data() {
        return {
            orderId: '',
            dateDatas: {},
            cusName: '',
            orderCode: '',
            printRecordIds: [],
            printInDialogVisible: false,
            printOutDialogVisible: false,
            type: 0,
            printType: 0
        };
    },
    mounted() {
        let that = this;
        that.orderId = that.$route.query.id;
        that.cusName = that.$route.query.cusName;
        that.orderCode = that.$route.query.orderCode;

        that.getOrderData();

        that.$util.getPrintComponents(2).then(data => {
            if (data) {
                Vue.component('printOutContent', () => import('@/components/printModels/' + data));
                that.isRegister = true;
            } else {
                Vue.component('printOutContent', () => import('@/components/printModels/printSalesOut'));
                that.isRegister = true;
            }
        });
    },
    methods: {
        // 获取数据
        getOrderData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpWarehouse/GetOrderInOutRecords',
                    data: { OrderId: this.orderId }
                })
                .then(res => {
                    let data = res.data;
                    this.dateDatas = data.DateDatas;
                    this.type = data.Type;
                })
                .catch(() => {});
        },
        handleSelectionChange(val, date) {
            let that = this;
            let selections = val;
            let newIds = [];
            if (selections) {
                //有选择
                that.dateDatas.forEach(el => {
                    if (el.Date == date) {
                        for (var i = 0; i < el.Records.length; i++) {
                            let result = '';
                            for (var j = 0; j < selections.length; j++) {
                                if (el.Records[i].RecordId == selections[j].RecordId) {
                                    result = selections[j].RecordId;
                                    break;
                                } else {
                                    result = '';
                                }
                            }

                            for (var z = 0; z < that.printRecordIds.length; z++) {
                                if (el.Records[i].RecordId == that.printRecordIds[z]) {
                                    that.printRecordIds.splice(z, 1);
                                }
                            }
                            if (result) newIds.push(result);
                        }
                    }
                });

                that.printRecordIds = that.printRecordIds.concat(newIds);
            } else {
                //清空某table的选择
                that.dateDatas.forEach(el => {
                    if (el.Date == date) {
                        for (var i = 0; i < el.Records.length; i++) {
                            for (var z = 0; z < that.printRecordIds.length; z++) {
                                if (el.Records[i].RecordId == that.printRecordIds[z]) {
                                    that.printRecordIds.splice(z, 1);
                                }
                            }
                        }
                    }
                });
            }
        },
        print(t) {
            if (t !== 0) {
                this.printType = 1;
                if (this.printRecordIds.length == 0) {
                    this.$util.warningMsg('请先选择需要打印的数据');
                    return;
                }
            }else{
                this.printType = 0;
            }
            if (this.type === 0) {
                this.printInDialogVisible = true;
            } else {
                this.printOutDialogVisible = true;
            }
        },
        closeDialog() {
            if (this.type === 0) {
                this.printInDialogVisible = false;
            } else {
                this.printOutDialogVisible = false;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.block {
    margin-top: 10px;
}
.el-table {
    margin-bottom: 0px;
}
.orderdata {
    font-size: 16px;
    font-weight: 700;
}
</style>
